export { PipeAttributesEditor as default };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormNumberInput, FormTextInput } from '../../../style/export';
import { PropertyLengthMeasure } from '../../../../catalog/properties/export';
import { FormLabel, FormSelect } from '../../../style/export';

var tableStyle = { width: '100%' };
var firstTdStyle = { width: '6em' };
var inputStyle = { textAlign: 'left' };

function PipeAttributesEditor(_ref, _ref2) {
  var element = _ref.element,
      _onUpdate = _ref.onUpdate,
      attributeFormData = _ref.attributeFormData,
      state = _ref.state,
      rest = _objectWithoutProperties(_ref, ['element', 'onUpdate', 'attributeFormData', 'state']);

  var translator = _ref2.translator;


  var name = attributeFormData.has('name') ? attributeFormData.get('name') : element.name;
  var vertexOne = attributeFormData.has('vertexOne') ? attributeFormData.get('vertexOne') : null;
  var vertexTwo = attributeFormData.has('vertexTwo') ? attributeFormData.get('vertexTwo') : null;
  var pipeLength = attributeFormData.has('pipeLength') ? attributeFormData.get('pipeLength') : null;
  var scene = state.scene;
  var floors = scene.get('floors');
  var floorID = element.floorID ? element.floorID : floors.first().id;

  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'floor-record' },
      React.createElement(
        'div',
        { className: 'floor-label' },
        React.createElement(
          FormLabel,
          null,
          translator.t("Floor")
        )
      ),
      React.createElement(
        FormSelect,
        { value: floorID, onChange: function onChange(event) {
            return _onUpdate('floorID', event.target.value);
          } },
        floors.toArray().map(function (floor, index) {
          return React.createElement(
            'option',
            { key: index, value: floor.id },
            floor.name
          );
        })
      )
    ),
    React.createElement(PropertyLengthMeasure, {
      value: pipeLength,
      onUpdate: function onUpdate(mapped) {
        return _onUpdate('pipeLength', mapped);
      },
      configs: { label: 'Length', min: 0, max: Infinity, precision: 2 },
      state: state
    })
  );
}

PipeAttributesEditor.propTypes = {
  element: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onValid: PropTypes.func,
  attributeFormData: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired
};

PipeAttributesEditor.contextTypes = {
  translator: PropTypes.object.isRequired
};